// /src/pages/private/members/rosterTools/api/rosterApi.js

import axios from "axios";
import { sanitizeSearchInput } from "../../../../../utils/sanitizeUserTextInput";

const DEFAULT_PAGE_SIZE = 25;

/**
 * @param {{ page?: number, pageSize?: number, search?: string, preferSelfPage?: boolean }} params
 */
export async function fetchRosterData(params = {}) {
  const page = Math.max(0, Number(params.page) || 0);
  const pageSize = Math.max(1, Number(params.pageSize) || DEFAULT_PAGE_SIZE);
  const search = sanitizeSearchInput(params.search);
  const preferSelfPage = params.preferSelfPage === true;

  const rosterRes = await axios.post(
    "/api/user/retrieve-roster",
    { page, pageSize, search, preferSelfPage },
    { withCredentials: true }
  );
  const d = rosterRes.data || {};
  return {
    rosterData: d.data || [],
    rosterWsMaxSeq: Number(d.rosterWsMaxSeq ?? 0),
    page: Number(d.page ?? page),
    pageSize: Number(d.pageSize ?? pageSize),
    pageCount: Math.max(1, Number(d.pageCount ?? 1)),
    totalPrimaries: Number(d.totalPrimaries ?? 0),
    stats: d.stats || { total: 0, exclusive: 0, certified: 0 },
    selfPage: d.selfPage != null ? Number(d.selfPage) : null,
    rowCount: Number(d.rowCount ?? (d.data || []).length)
  };
}

/**
 * @param {number[]|null} handleIds When set, only trainings for those handles.
 */
export async function fetchTrainingProgress(handleIds = null) {
  const body =
    Array.isArray(handleIds) && handleIds.length > 0
      ? { handleIds }
      : {};
  const trainingRes = await axios.post(
    "/api/user/retrieve-training-progress",
    body,
    { withCredentials: true }
  );
  return trainingRes.data?.trainings || {};
}

/** Roster page + trainings for visible handles (socket / full resync). */
export async function fetchRosterBundle(params = {}) {
  const roster = await fetchRosterData(params);
  const handleIds = roster.rosterData.map((r) => r.handleId);
  const trainings = await fetchTrainingProgress(handleIds);
  return {
    rosterData: roster.rosterData,
    trainings,
    rosterWsMaxSeq: roster.rosterWsMaxSeq,
    page: roster.page,
    pageSize: roster.pageSize,
    pageCount: roster.pageCount,
    totalPrimaries: roster.totalPrimaries,
    stats: roster.stats,
    selfPage: roster.selfPage
  };
}

export async function rosterLastSeen(lastSeenWsLogId) {
  const { data } = await axios.post(
    "/api/user/roster-last-seen",
    typeof lastSeenWsLogId === "undefined"
      ? {}
      : { lastSeenWsLogId },
    { withCredentials: true }
  );
  return data;
}

export async function getRosterDiff() {
  const { data } = await axios.post(
    "/api/user/roster-diff",
    {},
    { withCredentials: true }
  );
  return data;
}
